document.addEventListener('turbolinks:load', function() {
  $(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').stop(true).animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 80
    }, 300);
  });
});
